import React, { Component } from 'react'
import styles from './search.styles'
import injectSheet from 'react-jss'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import classNames from 'classnames'
import SearchIcon from 'react-icons/lib/fa/search'

class SchoolSearch extends Component {
  onChange = e => this.props.onChange(e.target.value)
  render() {
    const { classes, className } = this.props
    return (
      <div className={classNames(classes.container, className)}>
        <FormInput
          onChange={this.onChange}
          className={classes.input}
          id="schoolSearch"
          placeholder="Start searching for your school"
        />
        <label className={classes.label} htmlFor="schoolSearch">
          <SearchIcon />
        </label>
      </div>
    )
  }
}

export default injectSheet(styles)(SchoolSearch)
